// extracted by mini-css-extract-plugin
export default {"draftsContainer":"Drafts_draftsContainer__AnhMr"};